/**
 * Here is the logic for our redux reducers
 * activated by the actions.
 */

export const reducer = (state = { menuVisible: false, savedDocument: {} }, action) => {
	if (action.type === 'TOGGLE_SIDEBAR') {
		return {
			...state,
			menuVisible: !state.menuVisible,
		};
	}

	if (action.type === 'UPDATE_USER_DATA') {
		return {
			...state,
			userData: {
				...state.userData,
				...action.userData,
			},
		};
	}

	if (action.type === 'LOAD_DOCUMENT_FROM_DB') {
		return {
			...state,
			savedDocument: action.savedDocument,
		};
	}

	if (action.type === 'LOAD_PAGES_FROM_DB') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pagesLength: action.pagesLength ? action.pagesLength : state.savedDocument.pagesLength,
				pages: {
					...state.savedDocument.pages,
					...action.pages,
				},
			},
		};
	}

	if (action.type === 'REORDER_THUMBNAILS') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				thumbnails: action.newOrder,
			},
		};
	}

	if (action.type === 'SET_ENVELOPE_SELECTED_DOC') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				envelopeSelectedDoc: action.id,
			},
		};
	}

	if (action.type === 'FLUSH_ALL_PAGES') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pages: {},
			},
		};
	}

	if (action.type === 'UPDATE_EXTRACTED_FIELDS') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				extractedFields: {
					...state.savedDocument.extractedFields,
					...action.newValue,
				},
			},
		};
	}

	if (action.type === 'UPDATE_WORKSTEPS') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				worksteps: action.newValue,
			},
		};
	}

	if (action.type === 'UPDATE_ADDITIONAL_DATA') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				additionalFields: action.newData,
			},
		};
	}

	if (action.type === 'UPDATE_ADDITIONAL_TABS') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				additionalTabs: action.newTabs,
			},
		};
	}

	if (action.type === 'UPDATE_DOC_LIST_STATUS') {
		return {
			...state,
			docListStatus: {
				...state.docListStatus,
				...action.newValue,
			},
		};
	}

	if (action.type === 'REMOVE_PAGE_FROM_DOCUMENT') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pages: {
					...state.savedDocument.pages,
					[action.page]: {
						...state.savedDocument.pages[action.page],
						isDeleted: true,
					},
				},
			},
		};
	}

	if (action.type === 'UPDATE_TYPES_LIST') {
		return {
			...state,
			docTypesList: action.newList,
		};
	}

	if (action.type === 'UPDATE_REF') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				reference: action.newRef,
			},
		};
	}

	if (action.type === 'UPDATE_REC_REF') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				recognisedRef: action.newRecRef
			}
		}
	}

	if (action.type === 'ADD_LOADING_FLAG') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pages: {
					...state.savedDocument.pages,
					[action.page]: {
						...state.savedDocument.pages[action.page],
						isLoading: true,
					},
				},
			},
		};
	}

	if (action.type === 'REMOVE_FLAGS') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pages: {
					...state.savedDocument.pages,
					[action.page]: {
						pageUrl: state.savedDocument.pages[action.page].pageUrl,
					},
				},
			},
		};
	}

	if (action.type === 'REMOVE_MULTIPLE_PAGES') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				pages: {
					...state.savedDocument.pages,
					...action.pages,
				},
			},
		};
	}

	if (action.type === 'UPDATE_COMMENT') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				comments: {
					...state.savedDocument.comments,
					...action.updatedComment,
				},
			},
		};
	}

	if (action.type === 'UPDATE_APPROVED') {
		return {
			...state,
			savedDocument: {
				...state.savedDocument,
				approved: action.updatedApproved,
			},
		};
	}

	if (action.type === 'UPDATE_FILTERED_NAME') {
		return {
			...state,
			filterByName: action.filterByName,
		};
	}
	if (action.type === 'UPDATE_FILTERED_REFERENCE') {
		return {
		  ...state,
		  filterByReference: action.filterByReference, 
		};
	  }

	if (action.type === 'UPDATE_FILTERED_ENVELOPE_NAME') {
		return {
			...state,
			filterByEnvelopeName: action.filterByEnvelopeName,
		};
	}

	if (action.type === 'UPDATE_TOTAL_FILTERED_DOCS') {
		return {
			...state,
			totalFilteredDocs: action.totalFilteredDocs,
		};
	}

	return state;
};
